import { getEngine } from '@lio/rule-engine';
import { CodeName } from '@models/quoteItem';
import { writingCompanyIds } from '@models/productOffering';
import type { StructuredQuote, RuleEngine, AttributeType } from '@store/Quote/Quote.types';

const coverageTypeLabel = {
  Package: 'Package',
  Accident: 'Accident',
  ManagementLiability: 'Management Liability',
  Excess: 'Excess',
  PrimaryGeneralLiability: 'Primary General Liability',
};

const isSelectedAndActive = (ruleEngine: RuleEngine, attributeType: AttributeType | undefined) => {
  if (attributeType?.attribute?.value !== true) {
    return false;
  }

  return !!ruleEngine.execute(attributeType?.isActive);
};

export const getCoverageTypeText = (structuredQuote: StructuredQuote, writingCompanyId?: string): string => {
  const quoteItem = structuredQuote.quoteItems.find((item) => item.quoteItemType.codeName === CodeName.Policy);

  if (!quoteItem) {
    if (writingCompanyId && writingCompanyId === writingCompanyIds.specialty) {
      return coverageTypeLabel.PrimaryGeneralLiability;
    }
    return coverageTypeLabel.Package;
  }

  const ruleEngine = getEngine(structuredQuote);
  ruleEngine.setEngineInitialQuoteItem(quoteItem.id);

  if (isSelectedAndActive(ruleEngine, quoteItem.attributeTypes?.LOIExcessLiabilityInd)) return coverageTypeLabel.Excess;
  if (isSelectedAndActive(ruleEngine, quoteItem.attributeTypes?.LOIAccidentInd)) return coverageTypeLabel.Accident;
  if (isSelectedAndActive(ruleEngine, quoteItem.attributeTypes?.LOIManagementLiabilityInd))
    return coverageTypeLabel.ManagementLiability;

  if (writingCompanyId && writingCompanyId === writingCompanyIds.specialty) {
    return coverageTypeLabel.PrimaryGeneralLiability;
  }
  return coverageTypeLabel.Package;
};
